"use client";

import Link from "next/link";
import { useInhomzTrack } from "../../_hooks/useInhomzTrack";

// next/link that fires an inhomz event on click — lets Server Components
// (cards, footer) track without becoming client components themselves.
export default function TrackedLink({ event, properties, onClick, ...linkProps }) {
  const track = useInhomzTrack();

  return (
    <Link
      {...linkProps}
      onClick={(e) => {
        if (event) track(event, properties);
        onClick?.(e);
      }}
    />
  );
}
